import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { DotsThreeOutline } from '@phosphor-icons/react';
import { useDataSidebarContext } from './context';

interface ItemProps {
  icon: React.ReactNode;
  label: string;
  isActive?: boolean;
  isNested?: boolean;
  onClick?: () => void;
  onMenuClick?: (e: React.MouseEvent) => void;
}

export const Item: React.FC<ItemProps> = ({
  icon,
  label,
  isActive = false,
  isNested = false,
  onClick,
  onMenuClick,
}) => {
  const { isDarkMode, palette } = useDataSidebarContext();
  const [isHovered, setIsHovered] = useState(false);

  const textColor = isActive
    ? palette.blue[500]
    : isDarkMode
      ? palette.gray[300]
      : palette.gray[600];

  return (
    <Box
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px 8px',
        paddingLeft: isNested ? '24px' : '8px',
        cursor: 'pointer',
        borderRadius: '4px',
        backgroundColor: isActive
          ? isDarkMode
            ? palette.gray[800]
            : palette.blue[50]
          : 'transparent',
        '&:hover': {
          backgroundColor: isDarkMode ? palette.gray[800] : palette.blue[50],
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flex: 1,
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            color: textColor,
          }}
        >
          {icon}
        </Box>
        <Typography
          sx={{
            color: textColor,
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Typography>
      </Box>
      {isHovered && onMenuClick && (
        <Box
          component="button"
          onClick={e => {
            e.stopPropagation();
            onMenuClick(e);
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            color: isActive
              ? palette.blue[500]
              : isDarkMode
                ? palette.gray[400]
                : palette.gray[500],
          }}
        >
          <DotsThreeOutline size={16} weight="fill" />
        </Box>
      )}
    </Box>
  );
};
